import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import allImgPaths from "../../assets";
import { IconButton } from "../../components";
import Button from "../../components/controls/Button";
import TextBox from "../../components/controls/TextBox";
import { useAppState } from "../../context";
import { NewPasswordFormSchema } from "../../validations";

const NewPassword = () => {
  const { isLoading, changeNewPassword } = useAppState("auth");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const forgetpwdtoken = useParams();

  const {
    handleSubmit,
    getValues,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirmation: "",
      invalidInput: "",
    },
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(NewPasswordFormSchema),
  });

  const onSubmit = async () => {
    if (
      await changeNewPassword(
        forgetpwdtoken.token,
        getValues().password,
        getValues().passwordConfirmation,
      )
    ) {
      // setOpenModal(true);
    }
  };

  return (
    <>
      <form
        className="w-full bg-white border rounded-lg border-[#1c1c2c] border-opacity-25 px-3 pt-10 pb-4 mb-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="mt-8">
          <label htmlFor="" className="font-medium">
            New Password <span className="text-[red]">*</span>
          </label>
          <div className="relative">
            <TextBox
              label="Enter New Password"
              name="password"
              type={showNewPassword ? "text" : "password"}
              control={control}
              errors={errors}
            />
            <div className="absolute right-[13px] top-[12px] text-sm">
              {
                <IconButton
                  icon={
                    showNewPassword ? allImgPaths.eyeOpen : allImgPaths.eyeClose
                  }
                  type={"button"}
                  className="bg-[#1c1c2c] bg-opacity-0 mb-5"
                  onClick={() => {
                    setShowNewPassword(!showNewPassword);
                  }}
                />
              }
            </div>
          </div>
        </div>
        <div className="my-2">
          <label htmlFor="" className="font-medium">
            Confirm Password <span className="text-[red]">*</span>
          </label>
          <div className="relative">
            <TextBox
              label="Enter Confirm Password "
              name="passwordConfirmation"
              type={showConfirmPassword ? "text" : "password"}
              control={control}
              errors={errors}
            />
            <div className="absolute right-[13px] top-[12px] text-sm">
              {
                <IconButton
                  icon={
                    showConfirmPassword
                      ? allImgPaths.eyeOpen
                      : allImgPaths.eyeClose
                  }
                  type={"button"}
                  className="bg-[#1c1c2c] bg-opacity-0 mb-5"
                  onClick={() => {
                    setShowConfirmPassword(!showConfirmPassword);
                  }}
                />
              }
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center mt-6 gap-7">
          <div className="!w-full gap-4">
            <Button variant="contained" type="submit" className="!w-full">
              {isLoading ? "Loading..." : "Submit"}
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default NewPassword;
